<div class="whatsapp-fab" (click)="openWhatsApp()">
  <img
    src="https://img.icons8.com/color/48/000000/whatsapp.png"
    alt="whatsApp_fab_btn"
  />
</div>
